export default __webpack_public_path__ + "static/media/logInBg.31dfbaad.png";